/*
*   File : function.js
*   Author : https://evoqins.com
*   Description : Helper functions
*   Integrations : NA
*   Version : 1.0.0
*/

import { APIService } from "../Service";
import { toast } from "react-toastify";
import Store from "../Store/store";
import Cookies from "js-cookie";

// Custom data
export const BROKERS_LIST_DATA = [
    { "broker_name": "ACUMEN", "access_token_name": "access_token" },
    { "broker_name": "5PAISA", "access_token_name": "access_token" },
    { "broker_name": "PRABHUDASLILLADHER", "access_token_name": "access_token" },
    { "broker_name": "ANGEL_BROKER", "access_token_name": "access_token" },
    { "broker_name": "IIFL", "access_token_name": "access_token" },
    { "broker_name": "63MOONSBROKER", "access_token_name": "access_token" },
    { "broker_name": "ACAGARWAL_UAT", "access_token_name": "access_token" },
    { "broker_name": "LATIN_MANHARLAL", "access_token_name": "access_token" },
    { "broker_name": "ABIRA", "access_token_name": "access_token" },
    { "broker_name": "PAYTM", "access_token_name": "access_token" },
    { "broker_name": "NUVAMA", "access_token_name": "access_token" },
    { "broker_name": "FYERS", "access_token_name": "auth_code" },
    { "broker_name": "MOTILAL_OSWAL", "access_token_name": "access_token" },
    { "broker_name": "UPSTOX", "access_token_name": "code" },
    { "broker_name": "ZERODHA", "access_token_name": "request_token" },
    { "broker_name": "HDFC_SKY", "access_token_name": "access_token" }
];


export const _formatSIPDate = (sip_date) => {
    switch (sip_date) {
        case 1: return "1st of every month";
        case 2: return "2nd of every month";
        case 3: return "3rd of every month";
        case 21: return "21st of every month";
        case 22: return "22nd of every month";
        case 23: return "23rd of every month";
        case 31: return "31st of every month";
        default: return `${sip_date + "th of every month"}`;
    };
}

// handle format amount 
export const _formattedAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(amount);
};

// Scroll to top
export const _scrollToTop = () => {
    window.scrollTo({
        top: 0, behavior: 'smooth'
    });
};


//======================================= //
// ========== Common API CAllS ========== //

// Get user profile data
export const _getProfile = async (user_id) => {

    let url = "profile/get";
    let data = {
        "user_id": user_id
    };
    const response = await APIService(url, data);
    if (response && response.status_code === 200) {
        Store.dispatch({ type: "UPDATE_USER_DATA", payload: response.data });
    } else {
        let options = { domain: process.env.REACT_APP_DOMAIN, path: '/' };
        Store.dispatch({ type: "CLEAR_STORE" });
        Cookies.remove("indvestment_access_token", options);
        Cookies.remove("indvestment_user_id", options);
        toast.dismiss();
        toast.error(response.message);
        window.location.href = "/";
    }
    return response;
};

// Check broker connection status 
export const _checkBrokerStatus = async (selected_broker, user_id) => {
    let url = "broker/fund-details";
    let data = {
        "user_id": user_id,
        "broker_id": selected_broker.broker_id,
        "broker_name": selected_broker.broker_execution_name,
        "client_code": selected_broker.client_code,
        "source": "WEB",
    };
    const response = await APIService(url, data);
    return response;
};

// Get basket detail
export const _getBasketDetail = async (strategy_id, user_id, tenant_id) => {

    let url = "products/strategy-by-id";
    let data = {
        "strategy_id": strategy_id,
        "user_id": user_id,
        "tenant_id": Number(tenant_id)
    };

    let response = await APIService(url, data)
    return response;
};

// Get brokers list data
export const _getBrokersList = async () => {

    let url = "broker/list";
    let data = {
        "source": "WEB"
    };
    const response = await APIService(url, data);
    return response;
};

// Validate broker
export const _validateBroker = async (selected_broker, access_token, user_id) => {
    let url = "broker/validate";
    let data = {
        "user_id": user_id,
        "broker_id": selected_broker.broker_id,
        "access_token": access_token,
        "broker_name": selected_broker.broker_execution_name,
        "source": "WEB"
    };

    const response = await APIService(url, data);
    return response;
};




//////////// INVEST APIS - Order Creation ///////////////

// Generate Product code
export const _generateProductCode = async (params) => {
    let { basket_data, holdings, action, portfolio_id, user_id, broker_data, operation } = params;

    let url = "portfolio/get-product-code";
    let order_detail_request_list = holdings.map((holding) => ({
        "action": action || holding.action,
        "alphaniti_key": holding.alphaniti_key,
        "current_price": Number(holding.price || holding.current_value || holding.close),
        "isin": holding.isin,
        "portfolio_id": portfolio_id,
        "portfolio_stock_id": Number(holding.portfolio_stock_id) || null,
        "quantity": Number(holding.qty) || holding.quantity || holding.action_qty,
        "order_type": holding.order_type,
        "order_validity": holding.order_validity,
        "product_type": holding.product_type,
    }));
    let data = {
        "strategy_id": Number(basket_data.strategy_id),
        "user_id": user_id,
        "tenant_id": Number(basket_data.creator_info.creator_id),
        "client_code": broker_data.client_code,
        "execution_partner": broker_data.execution_partner,
        "portfolio_id": basket_data.portfolio_id,
        "source": "WEB",
        "operation": operation,
        "order_detail_request_list": order_detail_request_list
    };

    let response = await APIService(url, data);
    return response;
};

// Broker - Buy or Sell 
export const _openBrokerOrderPlatform = async (params) => {

    let { basket_data, holdings, user_id, product_code, transaction_type, broker_data } = params;

    let url = "broker/buysell";
    let baskets = holdings.map(holding => ({
        "exchange": holding.exchange_to_trade,
        "hdfc_security_id": holding.hdfc_security_id,
        "isin": holding.isin,
        "nuvama_trading_symbol": holding.nuvama_trade_symbol,
        "order_type": holding.order_type,
        "product_code": product_code,
        "quantity": Number(holding.qty) || holding.quantity,
        "price": Number(holding.price || holding.current_value || holding.close),
        "transaction_type": transaction_type || holding.action,
        "trading_symbol": holding.exchange_to_trade === "NSE" ? holding.nse_exchange_symbol : holding.bse_exchange_symbol,
    }));
    let data = {
        "access_token": broker_data.access_token,
        "broker_id": broker_data.broker_id,
        "broker_name": broker_data.broker_name,
        "client_code": broker_data.client_code,
        "tenant_id": Number(basket_data.creator_info.creator_id),
        "user_id": user_id,
        "fund_balance": Number(broker_data.available_cash),
        "source": "WEB",
        "basket": baskets
    }

    let response = await APIService(url, data);
    return response;

};

// Broker - Execute order - Manual
export const _executeBrokerOrder = async (params) => {

    let { holdings, product_code, broker_data, basket_data, user_id } = params;

    let url = "broker/execute-order";
    let baskets = holdings.map(holding => ({
        "exchange": holding.exchange_to_trade,
        "trading_symbol": holding.exchange_to_trade === "NSE" ? holding.nse_exchange_symbol : holding.bse_exchange_symbol,
        "nuvama_trading_symbol": holding.nuvama_trade_symbol,
        "quantity": Number(holding.qty || holding.quantity),
        "price": Number(holding.price || holding.current_value || holding.close),
        "value": Number(holding.price || holding.current_value || holding.close),
        "order_type": holding.order_type,
        "transaction_type": holding.action,
        "isin": holding.isin,
        "product_code": product_code,
        "validity": holding.order_validity,
        "product": holding.product_type,
        "scrip_code": holding.exchange_to_trade === "NSE" ? holding.nse_exchange_token : holding.bse_exchange_token,
        "variety": holding.order_type,
        "hdfc_security_id": holding.hdfc_security_id,
        "limit_price": holding.price,
        "stock_price": holding.price
    }));
    let data = {
        "strategy_id": Number(basket_data.strategy_id),
        "user_id": user_id,
        "tenant_id": Number(basket_data.creator_info.creator_id),
        "broker_name": broker_data.broker_name,
        "broker_id": broker_data.broker_id,
        "client_code": broker_data.client_code,
        "source": "WEB",
        "basket": baskets
    };

    let response = await APIService(url, data);
    return response;
};

// Validate broker order
export const _validateBrokerOrder = async (params) => {

    let { broker_data, access_token, creator_id, user_id } = params;

    let url = "broker/get-login-access-token";
    let data = {
        "request_type": broker_data.broker_name,
        "client_code": broker_data.client_code,
        "access_token": access_token,
        "tenant_id": Number(creator_id),
        "user_id": user_id,
    };

    let response = await APIService(url, data);
    return response;
};

// Create and update Portfolio 
export const _createAndUpdatePortFolio = async (params) => {

    let { product_code, portfolio_id, broker_data, investment_amount, operation, basket_data, user_id } = params;

    let url = "portfolio/create";
    let data = {
        "client_code": broker_data.client_code,
        "execution_partner": broker_data.execution_partner,
        "investment_amount": investment_amount,
        "operation": operation,
        "origination_source": broker_data.execution_partner,
        "product_code": product_code,
        "portfolio_id": portfolio_id,
        "source": "WEB",
        "strategy_id": Number(basket_data.strategy_id),
        "tenant_id": Number(basket_data.creator_info.creator_id),
        "user_id": user_id
    };

    let response = await APIService(url, data);
    return response;
};

// Getting Market status - To order
export const _getMarketStatus = async () => {
    let url = "broker/market-status";
    let is_post = false;
    let response = await APIService(url, null, is_post)
    return response;
};



